import { Modal, Pressable, StyleSheet } from "react-native";

import { colors } from "@/constants/colors";

interface Props {
  children: React.ReactNode;
  onClose: () => void;
  visible: boolean;
}

export default function AppModal({ children, onClose, visible }: Props) {
  return (
    <Modal
      animationType="fade"
      onRequestClose={onClose}
      transparent
      visible={visible}
    >
      <Pressable onPress={onClose} style={styles.backdrop}>
        <Pressable onPress={() => {}} style={styles.modal}>
          {children}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    alignItems: "center",
    backgroundColor: colors.darkOverlay,
    flex: 1,
    justifyContent: "center",
  },
  modal: {
    backgroundColor: colors.modal,
    borderRadius: 16,
    maxWidth: 420,
    padding: 24,
    width: "100%",
  },
});
